import React, { ReactElement } from "react";
import { WidgetProps } from "@rjsf/utils";
import { enums } from "../utils";
import RadioGroup, {
  RadioGroupProps
} from "@amzn/awsui-components-react-v3/polaris/radio-group";

export default function RadioWidget(props: WidgetProps): ReactElement {
  const { enumOptions, enumDisabled } = enums(props);

  const items: RadioGroupProps.RadioButtonDefinition[] = enumOptions.map(
    ({ value, label }) => ({
      disabled: enumDisabled?.includes(value),
      value,
      label
    })
  );

  return (
    <RadioGroup
      data-id={props.id}
      items={items}
      value={props.value}
      ariaRequired={props.required}
      onChange={e => props.onChange(e.detail.value)}
    />
  );
}
